import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const BIGPUSHBLOCK_LEGACY_FIELD_ORDER = [
  "heading",
  "text",
  "button_label",
  "button_link",
  "external_link",
  "icon",
  "background_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  bigPushBlockDescriptor: _generatedBigPushBlockDescriptor,
  bigPushBlockBlocDefinition,
  bigPushBlockDashboardLayout,
  bigPushBlockConfig,
  bigPushBlockResolveConfig,
  bigPushBlockProperties,
} = doodBlockConfig(
  {
    name: "Big push",
    componentType: 'BigPushBlockComponent',
    category: 'content',
    description: "Big push.",
    keywords: [],
    hideFromPicker: true,
    allowed_in: ["PushRowBlock"],
    sharedFields: {}
  },

  () => ({
    heading: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-push.heading.label",
        placeholder: "",
      }
    }),
    text: propertyValue({
      type: 'wysiwyg',
      value: '',
      options: {
        label: "pages.blocks.big-push.text.label",
      }
    }),
    button_label: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-push.button-label.label",
        placeholder: "",
      }
    }),
    button_link: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-push.button-link.label",
        help: "pages.blocks.big-push.button-link.help",
        placeholder: "",
      }
    }),
    external_link: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.big-push.external-link.label",
      }
    }),
    icon: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.big-push.icon.label",
        help: "pages.blocks.big-push.icon.help",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-800"},
      options: {
        label: "pages.blocks.big-push.background-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.big-push.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.big-push.fieldset.title.label",
            fields: ["heading"],
          },
          {
            legend: "pages.blocks.big-push.fieldset.text.label",
            fields: ["text"],
          },
          {
            legend: "pages.blocks.big-push.fieldset.button.label",
            fields: ["button_label", "button_link", "external_link"],
          },
          {
            legend: "pages.blocks.big-push.fieldset.icon.label",
            fields: ["icon"],
          },
          {
            legend: "pages.blocks.big-push.fieldset.appearance.label",
            fields: ["background_color"],
          },
        ],
      },
    ],
  })
);

export function bigPushBlockDescriptor(): IBlockDescriptor;
export function bigPushBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function bigPushBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedBigPushBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedBigPushBlockDescriptor, bigPushBlockProperties, fieldOrder);
}

export {
  bigPushBlockBlocDefinition,
  bigPushBlockDashboardLayout,
  bigPushBlockProperties,
  bigPushBlockConfig,
  bigPushBlockResolveConfig,
};

export type BigPushBlockConfig = typeof bigPushBlockConfig;
